import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    email: 'Preencha um e-mail válido',
    min: 'Mínimo de ${min} caracteres',
    max: 'Máximo de ${max} caracteres',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}',
    max: 'Deve ser menor ou igual a ${max}',
  },
});

const Schema = Yup.object().shape({
  initialData: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required(),
      address: Yup.string().required(),
      neighborhood: Yup.string().required(),
      number: Yup.string().required(),
      email: Yup.string().required(),
      phone1: Yup.string().required(),
      phone2: Yup.string().required(),
      state: Yup.string().required(),
    })
  )
});
export default Schema;